/* global axios */
import ApiClient from '../ApiClient';

class CopilotThreads extends ApiClient {
  constructor() {
    super('captain/copilot_threads', { accountScoped: true });
  }

  stop(params = {}) {
    return axios.post(`${this.url}/stop`, params);
  }
}

export default new CopilotThreads();
